module.exports = __webpack_public_path__ + "img/stock4.0b48f01b.png";